import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as Dialog from '@radix-ui/react-dialog';
import { closeModal } from '../features/map/modalSlice';
import { RootState } from '../store';

export function Modal() {
  const dispatch = useDispatch();
  
  const { isOpen, title, message, type, actionId } = useSelector(
    (state: RootState) => state.modal
  );

  const handleConfirmar = () => {
    // Evaluamos qué acción ejecutar basándonos en el ID guardado
    if (actionId === 'ELIMINAR_USUARIO_MAIN') {
      console.log('Ejecutando API para borrar usuario...');
      // Aquí metes tu lógica real o disparas otra acción de Redux (ej: deleteUser())
    }

    // Al terminar, cerramos el modal
    dispatch(closeModal());
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && dispatch(closeModal())}>
      <Dialog.Portal>
        <Dialog.Overlay className="modal-overlay" />
        <Dialog.Content className="modal-box">
          
          {title && <Dialog.Title className="modal-title">{title}</Dialog.Title>}
          <Dialog.Description className="modal-message">{message}</Dialog.Description>
          
          <div className="modal-buttons">
            {type === 'confirm' ? (
              <>
                <button className="small-button" onClick={() => dispatch(closeModal())}>
                  Cancelar
                </button>
                <button className="small-button" onClick={handleConfirmar}>
                  Confirmar
                </button>
              </>
            ) : (
              <button className="small-button" onClick={() => dispatch(closeModal())}>
                Aceptar
              </button>
            )}
          </div>

        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
